export function SubjectBadge({ subject }: { subject?: string }) {
  if (!subject) return null;
  const clean = subject.replace(/^subject:\s*/i, "").trim();
  if (!clean || clean.toLowerCase() === "general") return null;
  return (
    <span className="text-xs font-benton font-semibold px-2 py-0.5 rounded-xs border border-border bg-secondary/80 text-foreground">
      {clean}
    </span>
  );
}

export function StatusBadge({ status }: { status: string }) {
  const normalized = status.toLowerCase();
  
  let colorStyle = "bg-secondary text-muted-foreground border-border"; // default neutral

  if (["active", "confirmed", "completed"].includes(normalized)) {
    // Color 2: Success Emerald
    colorStyle = "bg-success/10 text-success border-success/30";
  } else if (["failed", "suspended", "error", "cancelled"].includes(normalized)) {
    // Color 3: Alert Red
    colorStyle = "bg-destructive/10 text-destructive border-destructive/30";
  } else if (["pending", "processing", "premium"].includes(normalized)) {
    // Color 1: Primary Warm Orange
    colorStyle = "bg-primary/10 text-primary border-primary/20";
  }

  const text = status.replace(/^status:\s*/i, "").trim();
  return (
    <span className={`text-xs font-benton font-semibold uppercase tracking-wider px-2 py-0.5 rounded-xs border ${colorStyle}`}>
      {text}
    </span>
  );
}

export function Shimmer({ className = "" }: { className?: string }) {
  return (
    <div className={`rounded-xs bg-muted/60 animate-pulse ${className}`} />
  );
}
